const initState = {
    activeTabIndex: 0,
    invoiceNumbers: [],
    deliveryNumbers: [],
    orderURI: '',
    invoiceURI: '',
    searchQuery: '',
    overAllOrderStatus:'',
    extensibleParameters:'',
    shipmentsId:'',
    mindate:'',
    hash:'',
    viewAllReturn:false
};

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_INOVICE_ITEM = 'SET_INOVICE_ITEM';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SHIPMENT_ITEM = 'SET_SHIPMENT_ITEM';
export const SET_ORDER_ITEM = 'SET_ORDER_ITEM';
export const SET_INVOICE_URI = 'SET_INVOICE_URI'
export const UPDATE_HASH = 'UPDATE_HASH';

export const setCurrenttab = (data) => ({ type: SET_ACTIVE_TAB, payload: data });
export const setInvoice = (data) => ({ type: SET_INOVICE_ITEM, payload: data });
export const setSearchQuery = (data) => ({ type: SET_SEARCH_QUERY, payload: data });
export const setShipments = (data) => ({ type: SET_SHIPMENT_ITEM, payload: data });
export const setOrder = data => ({ type: SET_ORDER_ITEM, payload: data });
export const setInvoiceURI = data => ({type: SET_INVOICE_URI, payload: data})
export const updateHash = data => ({type: UPDATE_HASH, payload: data});

export default (state = initState, action) => {
    switch (action.type) {
        case SET_ACTIVE_TAB:
            return { ...state, activeTabIndex: action.payload };
        case SET_INOVICE_ITEM:
            return { ...state, invoiceNumbers: action.payload };
        case SET_SHIPMENT_ITEM:
            return { ...state, deliveryNumbers: action.payload };
        case SET_SEARCH_QUERY:
            return { ...state, ...action.payload };
        case SET_ORDER_ITEM:
            return { ...state, orderURI: action.payload };
        case SET_INVOICE_URI:
            return { ...state, invoiceURI: action.payload };
        case UPDATE_HASH:
            return { ...state, ...action.payload };
        default:
            return state
    }
}
